module.exports = __webpack_public_path__ + "assets/img/menu_bg_8.91726764.png";